import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import { AppTabs } from '@client/foundation/design-system/components';
import { IndicatorsBuilder } from './indicators-builder';
import { StrategyBuilder } from './strategy-builder';
import { SignalBlocksBuilder } from './signal-blocks-builder';

type BuilderTab = 'indicators' | 'strategy' | 'signalBlocks';

const builderTabs: { value: BuilderTab; label: string }[] = [
  { value: 'indicators', label: 'Indicators' },
  { value: 'strategy', label: 'Strategy' },
  { value: 'signalBlocks', label: 'Signal Blocks' }
];

export const TemplateBuilders: React.FC = () => {
  const [tab, setTab] = useState<BuilderTab>('indicators');

  return (
    <Container
      maxWidth="xl"
      sx={{
        py: 2,
        minHeight: 'calc(100vh - 150px)',
        display: 'flex'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: '100%'
        }}
      >
        <AppTabs
          value={tab}
          onChange={setTab}
          tabs={builderTabs}
          sx={{ mb: 3 }}
        />

        <Box sx={{ flex: 1, minHeight: 0 }}>
          {tab === 'indicators' ? (
            <IndicatorsBuilder />
          ) : tab === 'strategy' ? (
            <StrategyBuilder />
          ) : (
            <SignalBlocksBuilder />
          )}
        </Box>
      </Box>
    </Container>
  );
};
